import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../services/firebase.config";
import openAIService from "../../services/OpenAIService";

export async function generateProfileOverview(quizData, displayName, userId) {
  if (!quizData || quizData.length === 0) {
    console.warn("⚠️ generateProfileOverview: No quiz data available");
    return null;
  }

  console.log("🧠 Starting generateProfileOverview with:", {
    quizCount: quizData.length,
    displayName: displayName || "this person",
    userId: userId,
  });

  try {
    console.log("🤖 Calling openAIService.generateProfileInsights...");
    console.log(
      "📊 Quiz data being sent to OpenAI:",
      quizData.map((quiz) => ({
        quizType: quiz.quizType,
        quizName: quiz.quizName,
        resultsCount: quiz.results?.length || 0,
        hasExistingInsights: !!quiz.insights,
      }))
    );

    const result = await openAIService.generateProfileInsights(
      quizData,
      displayName || "this person"
    );

    console.log("✅ OpenAI service returned result:", {
      success: result.success,
      hasInsights: !!result.insights,
      insightsLength: result.insights?.length || 0,
      timestamp: result.timestamp,
    });

    if (!result.success || !result.insights) {
      throw new Error("OpenAI service did not return valid insights");
    }

    console.log("💾 Saving profile overview to database...");
    const userProfileRef = doc(db, "public-profiles", userId);

    const profileInsightsData = {
      content: result.insights,
      generated: new Date().toISOString(),
      quizTypes: quizData.map((quiz) => quiz.quizType),
    };

    console.log("💾 Profile insights data to save:", {
      contentLength: profileInsightsData.content?.length || 0,
      quizTypes: profileInsightsData.quizTypes,
      generated: profileInsightsData.generated,
    });

    await updateDoc(userProfileRef, {
      profileInsights: profileInsightsData,
    });

    console.log("✅ Profile overview saved to database successfully");
    console.log("✅ generateProfileOverview completed successfully");
    return result.insights;
  } catch (err) {
    console.error("❌ generateProfileOverview failed:", err);
    console.error("❌ Error details:", {
      name: err.name,
      message: err.message,
      code: err.code,
      stack: err.stack?.split("\n").slice(0, 5),
    });
    throw err;
  }
}
